/**
 * Catalogue des jeux/modes classés, partagé par le classement (onglets,
 * podium, tableau) et le mini profil joueur (public et admin) : un seul
 * endroit où `id` (identifiant `gameId` côté API), `nameKey`/`modeKey`
 * (i18n), `icon` et `slug` (page de jeu, même valeur que `GAME_PAGE_SLUGS`
 * dans gulpfile.js) sont déclarés, pour que ces usages ne puissent jamais
 * diverger. Le score composite n'a pas de `slug` : il n'ouvre aucune page.
 */
export const GAME_GROUPS = [
    {
        id: "daily",
        nameKey: "home.dailyChallenge",
        icon: "/img/flame.svg",
        modes: [
            { id: "dailychallenge",     modeKey: "home.classic", type: "daily", total: 20, slug: "daily-challenge" },
            { id: "dailychallengehard", modeKey: "home.hard",    type: "daily", total: 20, slug: "daily-challenge-hard" },
        ],
    },
    {
        id: "flag",
        nameKey: "home.flagNerd",
        icon: "/img/flag.svg",
        modes: [
            { id: "flagnerd",           modeKey: "home.classic",  type: "classic", total: 193, slug: "flag-nerd-classic" },
            { id: "flagnerdhard",       modeKey: "home.hard",     type: "classic", total: 193, slug: "flag-nerd-hard" },
            { id: "flagnerd.speedrun",  modeKey: "home.speedRun", type: "speedrun",             slug: "flag-nerd-speed-run" },
        ],
    },
    {
        id: "map",
        nameKey: "home.mapNerd",
        icon: "/img/map.svg",
        modes: [
            { id: "mapnerdclassic", modeKey: "home.classic", type: "classic", total: 170, slug: "map-nerd-classic" },
            { id: "mapnerdhard",    modeKey: "home.hard",    type: "classic", total: 170, slug: "map-nerd-hard" },
        ],
    },
    {
        id: "capital",
        nameKey: "home.capitalNerd",
        icon: "/img/home-pin.svg",
        modes: [
            { id: "capitalnerd",          modeKey: "home.classic",  type: "classic", total: 193, slug: "capital-nerd-classic" },
            { id: "capitalnerdhard",      modeKey: "home.hard",     type: "classic", total: 193, slug: "capital-nerd-hard" },
            { id: "capitalnerd.speedrun", modeKey: "home.speedRun", type: "speedrun",             slug: "capital-nerd-speed-run" },
            { id: "capitalnerdreverse",   modeKey: "home.reverse",  type: "classic", total: 193, slug: "capital-nerd-reverse" },
        ],
    },
    {
        id: "country",
        nameKey: "home.countryNerd",
        icon: "/img/list.svg",
        modes: [
            { id: "countrynerd",     modeKey: "home.classic", type: "letters", total: 24, slug: "country-nerd" },
            { id: "countrynerdhard", modeKey: "home.hard",    type: "letters", total: 24, slug: "country-nerd-hard" },
        ],
    },
    {
        id: "usstates",
        nameKey: "home.usStates",
        icon: "/img/us-states.svg",
        modes: [
            { id: "usstatesclassic", modeKey: "home.classic", type: "classic", total: 50, slug: "us-states-classic" },
            { id: "usstateshard",    modeKey: "home.hard",    type: "classic", total: 50, slug: "us-states-hard" },
            // "letters" pilote juste l'affichage du classement (colonne "Erreurs" en
            // nombre plutôt qu'en cœurs) : List n'a pas de système de vies
            // (UsStatesList.js), donc "X vies restantes" n'aurait aucun sens.
            { id: "usstateslist",    modeKey: "home.list",    type: "letters", total: 50, slug: "us-states-list" },
        ],
    },
    {
        id: "global",
        nameKey: "leaderboard.global",
        icon: "/img/podium.svg",
        modes: [
            // Pas de `slug` : le score composite agrège tous les jeux, il n'a pas de
            // page de jeu propre à ouvrir (voir `Leaderboard.renderPlayCta()`).
            { id: "geonerdcomposite", modeKey: "leaderboard.composite", type: "composite", total: 1000 },
        ],
    },
];

/**
 * Groupes réellement proposés. Un groupe masqué est ignoré partout, y compris par
 * la résolution du hash du classement : un vieux lien `#countrynerd` retombe sur
 * l'onglet par défaut plutôt que d'afficher un classement sans onglet actif.
 */
export const VISIBLE_GROUPS = GAME_GROUPS.filter(g => !g.hidden);

/**
 * Le mode a-t-il un classement à ouvrir ? Faux pour le Lab (bêtas non classées)
 * et pour les zones continent (`flagnerd.af`, `mapnerdclassic.eu`…), qui ne sont
 * que de l'entraînement : un lien « Voir le classement » y mènerait à un
 * classement où la partie ne figure pas.
 */
export const isRankedGame = (gameId) =>
    VISIBLE_GROUPS.some(g => g.modes.some(m => m.id === gameId));
